import React from 'react';
import logo from '../logo.png';

const Loader = ({ show }) => {
  if (!show) return null;

  return (
    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
      <div className="text-center">
        <img 
          src={logo} 
          alt="Loading..." 
          height="100" 
          width= "100"
          className="spinning-logo mb-3"
        />
        <p className="text-white">Loading...</p>
      </div>
    </div>
  );
};

export default Loader;